import { gql } from 'src/__generated__';

const CREATE_REPORT_TEMPLATE_AND_TRIGGER = gql(`#graphql
mutation CreateReportTemplateAndTrigger($input: CreateReportTemplateInput!) {
  createReportTemplateAndTrigger(input: $input)
}`);

export default CREATE_REPORT_TEMPLATE_AND_TRIGGER;
